import React, { Component } from 'react';
import classNames from 'classnames';
import { insertTable } from 'lib/helpers';

export class InsertTableButton extends Component {
	render() {
		let { theme, disabled } = this.props;
		disabled = disabled || !this.canInsertTable();

		return (
			<div className={theme.buttonWrapper} title="插入表格">
				<button
					className={classNames(theme.button, {
						[theme.disabled]: disabled,
					})}
					disabled={disabled}
					onClick={this.handleClick}>
					<i className="qa-ico-table">表</i>
				</button>
			</div>
		)
	}

	canInsertTable() {

		/** @type {Draft.EditorState} */
		const editorState = this.props.store.getEditorState();
		const content = editorState.getCurrentContent();
		const selection = editorState.getSelection();

		if (!selection.isCollapsed()) return false;
		const blockKey = selection.getAnchorKey();
		const block = content.getBlockMap().get(blockKey);

		return block && !/\S/.test(block.getText());
	}

	handleClick = evt => {
		const { store, focusTable } = this.props;
		const { getEditorState, setEditorState } = store;
		const ref = { blockKey: null };
		insertTable({ getEditorState, setEditorState, ref });
		if (typeof focusTable === 'function' && ref.blockKey) {
			// wait for table to render
			requestAnimationFrame(() => focusTable(ref.blockKey));
		}
	};
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/tablePlugin/InsertTableButton.jsx